import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-payments',
  templateUrl: './payments-payments.component.html',
  styleUrls: ['./payments-payments.component.scss']
})
export class PaymentsPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
